// Base types
export interface User {
  id: string;
  email: string;
  profile_type: ProfileType | null;
  full_name: string | null;
  phone: string | null;
  organization: string | null;
  address: string | null;
  city: string | null;
  postal_code: string | null;
  created_at: string;
  updated_at: string;
  advisor_status?: AdvisorStatus;
  projects?: Project[];
  assigned_projects?: Project[];
}

export interface Project {
  id: string;
  name: string;
  description: string | null;
  status: ProjectStatus;
  domain: ProjectDomain;
  owner_id: string;
  assigned_advisor_id: string | null;
  assigned_funder_id?: string | null;
  created_at: string;
  updated_at: string;
  owner?: User;
  assigned_advisor?: User;
  assigned_funder?: User;
  steps?: Step[];
  documents?: Document[];
  current_status?: ProjectStatus;
  stages?: ProjectStage[];
  funding_amount?: number;
  funding_requested?: number;
}

export interface Step {
  id: string;
  name: string;
  description: string | null;
  status: StepStatus;
  due_date: string | null;
  completed_at: string | null;
  project_id: string;
  order_index: number;
  created_at: string;
  project?: Project;
}

export interface ProjectStage {
  id: string;
  project_id: string;
  status: ProjectStatus;
  reached_at: string;
  set_by_id: string;
  set_by_name?: string;
  note: string | null;
  created_at: string;
}

export interface ProjectTimeline {
  project_id: string;
  current_status: ProjectStatus;
  stages: ProjectStage[];
}

export interface ProjectTimeline {
  project_id: string;
  current_status: ProjectStatus;
  stages: ProjectStage[];
}

export interface Document {
  id: string;
  filename: string;
  file_url: string;
  file_size: number;
  mime_type: string;
  document_type: DocumentType;
  document_subtype?: string | null;
  project_id: string;
  uploaded_by: string;
  created_at: string;
  project?: Project;
  uploader?: User;
}

export interface Appointment {
  id: string;
  title: string;
  description: string | null;
  start_date: string;
  end_date: string;
  project_id: string | null;
  attendee_ids: string[];
  created_by: string;
  status: AppointmentStatus;
  created_at: string;
  project?: Project;
  attendees?: User[];
  creator?: User;
}

// Enums
export enum ProfileType {
  PORTEUR = 'PORTEUR',
  ACCOMPAGNATEUR = 'ACCOMPAGNATEUR',
  COORDINATEUR = 'COORDINATEUR',
  FINANCEUR = 'FINANCEUR',
  ADMIN = 'ADMIN'
}

export enum ProjectStatus {
  A_PREPARER = 'A_PREPARER',
  SOUMIS = 'SOUMIS',
  ACCORD_PROVISOIRE = 'ACCORD_PROVISOIRE',
  VALIDE = 'VALIDE',
  DEBLOCAGE_FONDS = 'DEBLOCAGE_FONDS',
  EN_COURS = 'EN_COURS',
  VERIFICATION_FINALE = 'VERIFICATION_FINALE',
  TERMINE = 'TERMINE',
  REJETE = 'REJETE',
  SUSPENDU = 'SUSPENDU'
}

export enum ProjectDomain {
  AGRICULTURE = 'AGRICULTURE',
  ARTISANAT = 'ARTISANAT',
  COMMERCE = 'COMMERCE',
  SERVICES = 'SERVICES',
  INDUSTRIE = 'INDUSTRIE',
  TOURISME = 'TOURISME',
  CULTURE = 'CULTURE',
  FORMATION = 'FORMATION',
  SOCIAL = 'SOCIAL',
  ENVIRONNEMENT = 'ENVIRONNEMENT'
}

export enum StepStatus {
  A_FAIRE = 'A_FAIRE',
  EN_COURS = 'EN_COURS',
  TERMINE = 'TERMINE',
  BLOQUE = 'BLOQUE',
  ANNULE = 'ANNULE'
}

export enum DocumentType {
  BUSINESS_PLAN = 'BUSINESS_PLAN',
  FINANCIAL_STATEMENT = 'FINANCIAL_STATEMENT',
  LEGAL_DOCUMENT = 'LEGAL_DOCUMENT',
  IDENTITY = 'IDENTITY',
  CERTIFICATE = 'CERTIFICATE',
  OTHER = 'OTHER'
}

export enum AppointmentStatus {
  PLANIFIE = 'PLANIFIE',
  CONFIRME = 'CONFIRME',
  TERMINE = 'TERMINE',
  ANNULE = 'ANNULE',
  REPORTE = 'REPORTE'
}

export enum AdvisorStatus {
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  PENDING = 'PENDING'
}

// UI/UX Types
export interface DashboardStats {
  totalProjects: number;
  activeProjects: number;
  completedProjects: number;
  pendingDocuments: number;
  upcomingAppointments: number;
  fundingTotal: number;
}

export interface FilterOptions {
  status?: ProjectStatus[];
  domain?: ProjectDomain[];
  assignedAdvisor?: string[];
  dateRange?: [string, string];
}